const INCHES_TO_CM = 2.54;

export const convertDimensionToMetric = (
  value: string | undefined,
  unit: string | undefined
): number | undefined => {
  if (!value || !unit) return undefined;

  const parsed = parseFloat(value);
  if (isNaN(parsed)) return undefined;

  if (unit === 'in') return parsed * INCHES_TO_CM;
  return parsed;
};
